/* eslint-disable max-statements */
/* eslint-disable complexity */
import React from "react";
import { useHistory, useLocation } from "react-router";
import PropTypes from "prop-types";
import styles from "./styles.css";
import InputText from "../../shared/input-text";
import Search from "../../shared/search";
import Button from "../../shared/button";
import { CDP_REDIRECTION_KEY, NUMBER, TRADE_STATE } from "../../../au-c2b/constants/app-constants";
import ScrewIcon from "./images/screw-icon.svg";
import { getYearInBackOrder } from "../../../utils/helpers/checkout-util";
import { getObjectByValue } from "../../../utils/helpers/get-keys-by-value";
import { validateEmail } from "../../../utils/validators/email-validator";
import ListTab from "../../shared/list-tab";
import splitOnUpperCase from "../../../utils/helpers/split-words";
import { setItem } from "../../../utils/helpers/storage-crud";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { AMPLITUDE_EVENT_NAMES, TRADE_IN_GA_EVENTS, TRADE_IN_BANNER_PROPERTY } from "./tracking";
import { trackDesktopCustomEventsAU, sendCustomGaEvents } from "../../../tracking";
import { getDeviceType } from "../../../utils/helpers/get-device-type";
import infoIcon from "./images/info.svg";
import BuildYearModal from "../build-year-modal/component";
import { trackC2bMobileCustomEvents } from "../../../au-c2b/tracking";
import { C2B_AU_MOBILE_EVENTS } from "../../../au-c2b/tracking/c2b-mobile-events";
import priceFormatter from "../../../utils/helpers/price-formatter";

const yearData = getYearInBackOrder(parseInt(new Date().getFullYear()), 0, NUMBER.TWENTY_FIVE);

const CdpEnterYourCarDetails = ({
    tradeInData = {},
    isLoggedIn,
    getGuestTokenConnect,
    setProfileDetailsConnect,
    setUserPersonalDetailsConnect,
    getTradeInDetailsConnect,
    getTradeVehicleDetailsConnect,
    updateTradeInConnect,
    setRedirectionDataConnect,
    createTradeInConnect,
    userEmail,
    setIsEditFlow,
    mobile
}) => {
    const [rego, setRego] = React.useState(tradeInData.regNo || "");
    const [buildYear, setBuildYear] = React.useState(tradeInData.buildYear || "");
    const [variantList, setVariantList] = React.useState([]);
    const [showVariantList, setShowVariantList] = React.useState(false);
    const [selectedState, setSelectedState] = React.useState(tradeInData.state || "");
    const [email, setEmail] = React.useState(userEmail || "");
    const [ododmeter, setOdometer] = React.useState(tradeInData.odometerReading || "");
    const [proceedLoading, setProceedLoading] = React.useState(false);
    const [selectedVariant, setSelectedVariant] = React.useState({
        ...(tradeInData.tradeInServiceProviderId && { tradeInServiceProviderId: tradeInData.tradeInServiceProviderId }),
        ...(tradeInData.variant && { variant: tradeInData.variant })
    });
    const [valuationLoading, setValuationLoading] = React.useState(false);
    const [showBuildYearModal, setShowBuildYearModal] = React.useState(false);

    const history = useHistory();
    const location = useLocation();
    const { pathname } = location;

    const resetToScreenOne = () => {
        setShowVariantList(false);
        setVariantList([]);
    };

    const handleBuildYearChange = (e) => {
        setBuildYear(e.value);
        trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.yearSelected, {
            ...TRADE_IN_BANNER_PROPERTY,
            eventAction: "year_selected"
        });
        resetToScreenOne();
    };

    const handleStateChange = (e) => {
        setSelectedState(e.value);
        trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.stateSelected, {
            ...TRADE_IN_BANNER_PROPERTY,
            eventAction: "state_selected"
        });
        resetToScreenOne();
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        resetToScreenOne();
    };

    const handleSelectVariant = (data) => {
        setSelectedVariant({ variant: data.variant, tradeInServiceProviderId: data.id });
        trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.variantSelected, {
            ...TRADE_IN_BANNER_PROPERTY,
            eventAction: "variant_selected"
        });
    };

    const handleRegoChange = (e) => {
        if (e.target.value.length > NUMBER.SIXTEEN + 1) return;
        setRego(e.target.value);
        resetToScreenOne();
    };

    const updateTradeIn = async (createRequest) => {
        try {
            const response = await getTradeVehicleDetailsConnect(createRequest);
            const { vehicleMetaDataList = [], userSelectedState = "", state = "" } = response.data || {};
            if (response.responseStatus && response.responseStatus.status === NUMBER.ONE_THOUSAND_THIRTEEN) {
                const orderId = createRequest && createRequest.c2bOrderId;
                const orderData = await updateTradeInConnect({
                    ...createRequest,
                    makeModelFlow: true,
                    firstTradeMode: "BANNER"
                });
                const { screenStep = "make" } = orderData.mmvyUserInputs || {};
                const redirectionDataObj = {
                    from: "cdp",
                    redirectLink: pathname
                };
                setRedirectionDataConnect(redirectionDataObj);
                setItem(redirectionDataObj, CDP_REDIRECTION_KEY);
                history.push(`/sell-your-car/trade-in-car-make/${screenStep}/${orderId}`);
                trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.mmyOpened, {
                    ...TRADE_IN_BANNER_PROPERTY,
                    eventAction: "mmy_opened"
                });
            } else {
                await updateTradeInConnect({
                    ...createRequest,
                    userSelectedState,
                    state: state ? state : createRequest.state,
                    tradeInServiceProviderId: vehicleMetaDataList[0].id,
                    firstTradeMode: "BANNER"
                });
                setVariantList(vehicleMetaDataList);
            }
        } catch (error) {
            throw error;
        }
    };

    const createTradeIn = async (createRequest) => {
        try {
            const response = await getTradeVehicleDetailsConnect(createRequest);
            const { vehicleMetaDataList = [], userSelectedState = "", state = "" } = response.data || {};
            if (response.responseStatus && response.responseStatus.status === NUMBER.ONE_THOUSAND_THIRTEEN) {
                const orderData = await createTradeInConnect({
                    ...createRequest,
                    makeModelFlow: true,
                    firstTradeMode: "BANNER",
                    "source": getDeviceType()
                });
                const redirectionDataObj = {
                    from: "cdp",
                    redirectLink: pathname
                };
                setRedirectionDataConnect(redirectionDataObj);
                setItem(redirectionDataObj, CDP_REDIRECTION_KEY);
                history.push(`/sell-your-car/trade-in-car-make/make/${orderData.data.c2bOrderId}`);
                getTradeInDetailsConnect({ fromCdp: true });
                trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.mmyOpened, {
                    ...TRADE_IN_BANNER_PROPERTY,
                    eventAction: "mmy_opened"
                });
            } else {
                await createTradeInConnect({
                    ...createRequest,
                    userSelectedState,
                    state: state ? state : createRequest.state,
                    tradeInServiceProviderId: vehicleMetaDataList[0].id,
                    firstTradeMode: "BANNER",
                    "source": getDeviceType()
                });
                if (vehicleMetaDataList.length === NUMBER.ONE) {
                    setSelectedVariant({
                        variant: vehicleMetaDataList[0].variant,
                        tradeInServiceProviderId: vehicleMetaDataList[0].id
                    });
                }
                setVariantList(vehicleMetaDataList);
            }
        } catch (err) {
            throw err;
        }
    };

    const handleOdometerChange = (e) => {
        const numericValue = e.target.value.replace(/\D/g, "");
        setOdometer(numericValue);
    };

    const handleProceedClick = async () => {
        if (!isLoggedIn) {
            const response = await getGuestTokenConnect({ username: email, mobile, addressType: "EMAIL", token: "" });
            setProfileDetailsConnect({
                secureToken: response.access_token,
                email
            });
            setUserPersonalDetailsConnect({ userEmail: email });
        }

        const createRequest = {
            year: buildYear,
            regNo: rego,
            state: selectedState,
            buildYear,
            makeModelFlow: null
        };
        setProceedLoading(true);
        try {
            const tradeInResponse = await getTradeInDetailsConnect({fromCdp: true});
            const { c2bOrderId, tradeInServiceProviderId, variant, year } = tradeInResponse || {};
            if (c2bOrderId) {
                const reqObj = {
                    ...createRequest,
                    c2bOrderId,
                    year: buildYear,
                    tradeInServiceProviderId: selectedVariant.tradeInServiceProviderId
                };

                await updateTradeIn({
                    ...reqObj,
                    year: year ? year : buildYear
                });
                setSelectedVariant({
                    ...(tradeInServiceProviderId && { tradeInServiceProviderId }),
                    ...(variant && { variant })
                });
            } else {
                await createTradeIn(createRequest);
            }
        } catch (error) {
            if (error.errorCode === NUMBER.FOUR_HUNDRED_FOUR) {
                await createTradeIn(createRequest);
            }
        } finally {
            setProceedLoading(false);
        }
    };

    const resetStates = () => {
        setRego("");
        setBuildYear("");
        setSelectedState("");
        setEmail("");
        setVariantList([]);
        setSelectedVariant({});
        setOdometer("");
        setIsEditFlow(false);
    };

    const handleGetValuationClick = async () => {
        setValuationLoading(true);
        const response =   {
            ...tradeInData,
            ...(tradeInData.damageType && {damaged: true}),
            accepted: false,
            odometerReading: ododmeter,
            variant: selectedVariant.variant,
            "firstTradeMode": "BANNER",
            makeModelFlow: null,
            tradeInServiceProviderId: selectedVariant.tradeInServiceProviderId
        };
        try {
            await updateTradeInConnect(response);
            await getTradeInDetailsConnect({fromCdp: true});
            setValuationLoading(false);
            resetStates();
            await yieldToMain();
            trackDesktopCustomEventsAU(TRADE_IN_GA_EVENTS.valuationClicked, {
                ...TRADE_IN_BANNER_PROPERTY,
                eventAction: "get_valuation_clicked"
            });
        } catch (error) {
            setValuationLoading(false);
        }
    };

    const handleOnBlur = (gaAction) => {
        sendCustomGaEvents({
            ...TRADE_IN_BANNER_PROPERTY,
            eventAction: gaAction
        });
    };

    const showBuildYearModalHandler = () => {
        trackC2bMobileCustomEvents(C2B_AU_MOBILE_EVENTS.BUILD_YEAR_TOOLTIP_CLICKED, {
            eventCategory: "Cars24_detail_page",
            eventLabel: "sell_banner"
        });
        setShowBuildYearModal(true);
    };

    React.useEffect(() => {
        if (variantList.length > 0) {
            setShowVariantList(true);
            if (variantList.length === NUMBER.ONE) {
                setSelectedVariant({variant: variantList[0].variant, tradeInServiceProviderId: variantList[0].id});
            }
        } else {
            setShowVariantList(false);
        }
    }, [variantList]);

    return (
        <div styleName={"styles.formOuter"}>
            <p styleName={"styles.heading"}>Enter your car details below</p>
            <div styleName={"styles.formWrapper"}>
                <div styleName={`styles.customInputStyle ${isLoggedIn ? "styles.customWidthRego" : ""}`}>
                    <InputText
                        regoEntered
                        onBlurCallback={() => {
                            handleOnBlur(TRADE_IN_GA_EVENTS.regoEntered.eventAction, AMPLITUDE_EVENT_NAMES.regoEntered);
                        }}
                        placeholder="ENTER REGO"
                        onChange={handleRegoChange}
                        value={rego}
                    />
                    {Array(NUMBER.FOUR)
                        .fill({})
                        .map((_, index) => (
                            <span styleName={"styles.circle"} key={index}>
                                <img src={ScrewIcon} alt="icon" />
                            </span>
                        ))}
                </div>
                <div styleName={isLoggedIn ? "styles.customRightFormWrap" : "styles.rightForm"}>
                    <div>
                        <p styleName={"styles.inputLabel"}>Build year<img src={infoIcon} alt="build year info icon" onClick={showBuildYearModalHandler}/></p>
                        <BuildYearModal open={showBuildYearModal} hideModal={() => setShowBuildYearModal(false)} />
                        <div styleName={isLoggedIn ? "styles.customWidthSearchs" : "styles.searchWrap"}>
                            <Search
                                value={buildYear ? { label: buildYear, value: buildYear } : ""}
                                placeholder={"Year"}
                                isSearchable={true}
                                data={yearData}
                                onChange={handleBuildYearChange}
                                tabAccessibility
                            />
                        </div>
                    </div>
                    <div>
                        <p styleName={"styles.inputLabel"}>State</p>
                        <div styleName={isLoggedIn ? "styles.customWidthSearchs" : "styles.searchWrap"}>
                            <Search
                                value={selectedState ? getObjectByValue(TRADE_STATE, "value", selectedState) : ""}
                                placeholder={"State"}
                                isSearchable={true}
                                data={TRADE_STATE}
                                onChange={handleStateChange}
                                tabAccessibility
                            />
                        </div>
                    </div>
                    { !isLoggedIn && (<div>
                        <p styleName={"styles.inputLabel"}>Enter your email address</p>
                        <div styleName={"styles.emailAddress"}>
                            <InputText
                                id="userEmail"
                                placeholder="Enter email address"
                                value={email}
                                onChange={handleEmailChange}
                                validator={validateEmail}
                                errorMessage={"Please enter a valid email address"}
                            />
                        </div>
                    </div>)
                    }
                </div>
            </div>
            {variantList.length > 0 && (
                <div styleName={"styles.variantWrapper"}>
                    <div styleName={"styles.variantDetails"}>
                        <div styleName={"styles.carsVariantHeading"}>
                            <p styleName={"styles.selectOption"}>Select your car’s variant</p>
                        </div>
                    </div>
                    <div styleName={"styles.variantListStyle"}>
                        {variantList.map((item) => (
                            <ListTab
                                key={item.id}
                                data={item}
                                dataKey={"id"}
                                selectedKey={selectedVariant.tradeInServiceProviderId}
                                labelKey={"variant"}
                                className={"col-12"}
                                styleName={"styles.column"}
                                onClick={() => handleSelectVariant(item)}
                            >
                                <div styleName="styles.carWrapper">
                                    <p styleName={"styles.carName"}>
                                        {item.make} {item.model}
                                    </p>
                                    <p styleName={"styles.carDetails"}>
                                        {item.variant} {item.driveType} | {splitOnUpperCase(item.transmission)} |{" "}
                                        {item.body} | {item.fuel}
                                    </p>
                                </div>
                            </ListTab>
                        ))}
                    </div>
                </div>
            )}
            { showVariantList && (
                <div styleName={"styles.getValuationStyle"}>
                    <Button
                        text="Get valuation"
                        disabled={Object.keys(selectedVariant).length === 0 || !ododmeter || ododmeter < NUMBER.ZERO || ododmeter >= NUMBER.THREE_LAKH_FIFTY_THOUSAND}
                        onClick={handleGetValuationClick}
                        isLoading={valuationLoading}
                        customStyle={["inter-btn-design"]}
                    />
                    { selectedVariant.tradeInServiceProviderId &&  (
                        <div styleName="styles.odometerInput">
                            <p styleName={"styles.odometerHeading"}>Enter odometer reading</p>
                            <InputText
                                type="number"
                                onBlurCallback={() => {
                                    handleOnBlur(TRADE_IN_GA_EVENTS.odoEntered.eventAction, AMPLITUDE_EVENT_NAMES.odoEntered);
                                }}
                                value={ododmeter}
                                onChange={handleOdometerChange}
                                placeholder="Odometer reading"
                                validator={(value) => value >= NUMBER.ZERO && value < NUMBER.THREE_LAKH_FIFTY_THOUSAND}
                                errorMessage={`Odometer reading must be between 0 and ${priceFormatter(NUMBER.THREE_LAKH_FIFTY_THOUSAND)}`}
                            />
                            <p styleName={"styles.odoText"}>Enter your odometer reading in KMs</p>
                        </div>
                    )}

                </div>
            )}
            <div styleName={"styles.buttonWrapper"}>
                {variantList.length === 0 && (
                    <Button
                        text="Proceed"
                        disabled={
                            (!isLoggedIn && !validateEmail(email)) || !buildYear || !selectedState || !rego
                        }
                        onClick={handleProceedClick}
                        isLoading={proceedLoading}
                        customStyle={["inter-btn-design"]}
                    />
                )}
            </div>
        </div>
    );
};

CdpEnterYourCarDetails.propTypes = {
    isLoggedIn: PropTypes.bool,
    getGuestTokenConnect: PropTypes.func,
    setProfileDetailsConnect: PropTypes.func,
    getTradeInDetailsConnect: PropTypes.func,
    getTradeVehicleDetailsConnect: PropTypes.func,
    updateTradeInConnect: PropTypes.func,
    createTradeInConnect: PropTypes.func,
    tradeInData: PropTypes.object,
    setUserPersonalDetailsConnect: PropTypes.func,
    gaId: PropTypes.string,
    setRedirectionDataConnect: PropTypes.func,
    redirectionData: PropTypes.object,
    userEmail: PropTypes.string,
    setIsEditFlow: PropTypes.func,
    mobile: PropTypes.string
};

export default CdpEnterYourCarDetails;
